import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
  ApiController,
  ApiExecutor,
  ApiResponse,
  ApiValidationService,
  Body,
  DELETE,
  GET,
  Header,
  POST,
  PUT,
  Params,
  Query,
} from '@app/core/api';
import {CreateContactGroupRequestDto} from '../dto/create-contact-group-request.dto';
import type {
  ContactGroupListQueryModel,
  ContactGroupModel,
  ContactGroupPageModel,
} from './contacts-api.models';

@ApiController('api/app/contact-group')
@Injectable({providedIn: 'root'})
export class ContactsGroupsApiService {
  constructor(
    public apiExecutor: ApiExecutor,
    public apiValidationService: ApiValidationService,
  ) {}

  @GET()
  listGroups(@Query() query: ContactGroupListQueryModel): Observable<ApiResponse<ContactGroupPageModel>> {
    return {} as Observable<ApiResponse<ContactGroupPageModel>>;
  }

  @POST()
  createGroup(@Body() body: CreateContactGroupRequestDto): Observable<ApiResponse<ContactGroupModel>> {
    return {} as Observable<ApiResponse<ContactGroupModel>>;
  }

  @PUT('/:groupId')
  @Header({'Content-Type': 'application/json'})
  updateGroup(
    @Params('groupId') groupId: number,
    @Body() name: string,
  ): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }

  @DELETE('/:groupId')
  deleteGroup(@Params('groupId') groupId: number): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }

  @GET('/:groupId')
  getGroupDetail(
    @Params('groupId') groupId: number,
    @Query() query: ContactGroupListQueryModel,
  ): Observable<ApiResponse<ContactGroupModel>> {
    return {} as Observable<ApiResponse<ContactGroupModel>>;
  }
}
